(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ensamble-ibq', {
            parent: 'entity',
            url: '/ensamble-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.ensamble.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ensamble/ensamblesibq.html',
                    controller: 'EnsambleIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ensamble');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ensamble-ibq-detail', {
            parent: 'ensamble-ibq',
            url: '/ensamble-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.ensamble.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ensamble/ensamble-ibq-detail.html',
                    controller: 'EnsambleIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ensamble');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Ensamble', function($stateParams, Ensamble) {
                    return Ensamble.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ensamble-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ensamble-ibq-detail.edit', {
            parent: 'ensamble-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ensamble/ensamble-ibq-dialog.html',
                    controller: 'EnsambleIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ensamble', function(Ensamble) {
                            return Ensamble.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ensamble-ibq.new', {
            parent: 'ensamble-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ensamble/ensamble-ibq-dialog.html',
                    controller: 'EnsambleIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ensamble-ibq', null, { reload: 'ensamble-ibq' });
                }, function() {
                    $state.go('ensamble-ibq');
                });
            }]
        })
        .state('ensamble-ibq.edit', {
            parent: 'ensamble-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ensamble/ensamble-ibq-dialog.html',
                    controller: 'EnsambleIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ensamble', function(Ensamble) {
                            return Ensamble.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ensamble-ibq', null, { reload: 'ensamble-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ensamble-ibq.delete', {
            parent: 'ensamble-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ensamble/ensamble-ibq-delete-dialog.html',
                    controller: 'EnsambleIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Ensamble', function(Ensamble) {
                            return Ensamble.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ensamble-ibq', null, { reload: 'ensamble-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
